export const EMAIL_MAX_LENGTH = 80;
export const EMAIL_LOCAL_PART_MAX_LENGTH = 64;

export const emailLocalPartMaxLength = (value: string): boolean => {
    if (!value) {
        return true;
    }

    const atIndex = value.indexOf('@');
    return atIndex === -1 || atIndex <= EMAIL_LOCAL_PART_MAX_LENGTH;
};
